import { useContext } from 'react'
import { LayoutResponsiveContext } from './layout-responsive-context'

/**
 * Hook that exposes screen dimensions and if the device is mobile.
 * @returns {WindowContext}
 */
export const useResponsive = () => {
  return useContext(LayoutResponsiveContext)
}
